import { OperationImportContextModel } from '../operation-import-context-model';

export class MicrosoftOfficeOperationProtectionContextBaseModel extends OperationImportContextModel {
  isPremium: boolean|null;
}
